import styles from './HeroStatsBar.module.css';

/**
 * The three services, in the order an opportunity passes through them.
 *
 * WHAT THIS REPLACED. "10K+ businesses trust us", "99.9% uptime guarantee",
 * "50+ countries worldwide" -- three numbers, none of them measured, on an
 * internal tool with one customer. Invented figures are worth less than no
 * figures: anyone who works here knows they are not real, and nobody else
 * sees this page.
 *
 * AND WHY IT IS NOT LIVE DATA EITHER. Real counts were the obvious fix, but
 * this page renders before anyone has signed in, so the numbers would have to
 * come from a new PUBLIC endpoint -- publishing how many companies have been
 * classified and how many contacts enriched to anyone who can reach the host.
 * The auth middleware exempts five paths and the one webhook among them still
 * demands a shared secret; adding a metrics endpoint beside them to decorate a
 * login screen is a poor trade.
 *
 * Naming the services says something true, needs no endpoint, and discloses
 * nothing. Each sub-line is two words, so the row stays a row.
 */
const SERVICES = [
  { name: 'Discovery', detail: 'Hiring signals' },
  { name: 'Enrichment', detail: 'Verified contacts' },
  { name: 'Outreach', detail: 'Approved messaging' },
] as const;

export function HeroStatsBar() {
  return (
    <div className={styles.statsBar} aria-label="What the platform does">
      {SERVICES.map(({ name, detail }, index) => (
        <div className={styles.group} key={name}>
          {index > 0 && <div className={styles.divider} aria-hidden="true" />}
          <div className={styles.statItem}>
            <span className={styles.statValue}>{name}</span>
            <span className={styles.statLabel}>{detail}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
